module.exports = __webpack_public_path__ + "media/images/checkbox-inactive-506a484a81190e4ed2ad502e42b7a828.svg";